<div class="container-chart">
  <div class="container-radio-group">
    <nz-radio-group class="radio-group" [(ngModel)]="option">
      <label nz-radio-button nzValue="A" *ngIf="viewMonthly && viewWeekly">Total</label>
      <label nz-radio-button nzValue="B" *ngIf="viewMonthly">Mensual</label>
      <label nz-radio-button nzValue="C" *ngIf="viewWeekly">Semanal</label>
    </nz-radio-group>
  </div>
  <div *ngIf="option === 'A'" class="container-pie-chart">
    <dx-pie-chart
      class="pie-chart"
      [dataSource]="dataArray1"
      type="doughnut"
      [customizePoint]="customizePoint"
      [innerRadius]="0.8"
      [centerTemplate]="chart === 'chart1' ? 'centerTemplate' : 'centerTemplate2'"
    >
      <dxo-legend
        markerTemplate="markerTemplate"
        [customizeText]="customizeLegendText"
      >
        <svg
          *dxTemplate="let item of 'markerTemplate'"
          attr.fill="{{ getMarkerColor(item) }}"
        >
          <!-- Color marker -->
          <circle
            cx="8"
            cy="10"
            r="6"
            [attr.fill]="item.marker.fill"
          ></circle>

          <!-- Categoría (Por autorizar / Autorizadas) -->
          <text
            x="20"
            y="13"
            font-size="12"
            font-family="Poppins"
            font-weight="400"
            fill="#001D44"
          >
            {{ item.argument }}
          </text>

          <!-- Valor formateado como moneda -->
          <text
            x="2"
            y="35"
            font-size="16"
            font-family="Poppins"
            font-weight="600"
            fill="#001D44"
          >
            {{ item.points[0].data?.count | currency:'':'$':'1.2-2':'en-US' }}
          </text>
        </svg>
      </dxo-legend>
      <dxi-series
        argumentField="title"
        valueField="count"
      >
      </dxi-series>
      <dxo-tooltip
        [enabled]="true"
        [customizeTooltip]="customizeTooltip"
      >
      </dxo-tooltip>
      <svg *dxTemplate="let pie of 'centerTemplate'">
        <text
          text-anchor="middle"
          y="60"
          x="50%"
          fill="rgba(0, 0, 0, 0.45)"
          font-size="14"
          font-family="Poppins"
        >
          Total requisitado
        </text>
        <text
          text-anchor="middle"
          y="80"
          x="50%"
          fill="#001D44"
          font-size="16"
          font-family="Poppins"
        >
          {{ totalAmount | currency:'':'$':'1.2-2':'en-US' }}
        </text>
      </svg>
      <svg *dxTemplate="let pie of 'centerTemplate2'">
        <text
          text-anchor="middle"
          y="60"
          x="50%"
          fill="rgba(0, 0, 0, 0.45)"
          font-size="14"
          font-family="Poppins"
        >
          En compras
        </text>
        <text
          text-anchor="middle"
          y="80"
          x="50%"
          fill="#001D44"
          font-size="16"
          font-family="Poppins"
        >
          {{ totalAmount | currency:'':'$':'1.2-2':'en-US' }}
        </text>
      </svg>
    </dx-pie-chart>
  </div>
  <div *ngIf="option === 'B'" class="container-pie-chart">
    <dx-chart
      class="pie-chart"
      [dataSource]="chartMonthlyDataSource"
    >
      <dxi-series
        argumentField="month"
        valueField="totalRequisited"
        type="bar"
        color="#021F79"
      >
      </dxi-series>
      <dxo-tooltip
        [enabled]="true"
        [customizeTooltip]="customizeTooltipBars"
      >
      </dxo-tooltip>
      <dxo-legend [visible]="false">
      </dxo-legend>
    </dx-chart>
  </div>
  <div *ngIf="option === 'C'" class="container-pie-chart">
    <dx-chart
      class="pie-chart"
      [dataSource]="chartWeeklyDataSource"
    >
      <dxi-series
        argumentField="weekStart"
        valueField="totalRequisited"
        type="bar"
      >
      </dxi-series>
      <dxo-tooltip
        [enabled]="true"
        [customizeTooltip]="customizeTooltipBars"
      >
      </dxo-tooltip>
      <dxo-legend [visible]="false">
      </dxo-legend>
    </dx-chart>
  </div>
</div>
